module.exports = __webpack_public_path__ + "static/media/tab-1-image-2.18884efd.png";